import styled from 'styled-components';

export const HomeContainer = styled.div`
  margin: 16px 16px;
`;
